  const newProductsSlider = new Swiper(".new-products-swiper", {
    speed: 1600,
    slidesPerView: "auto",
    centeredSlides: false,
    slidesPerGroup: 1,
    spaceBetween: 0,
    watchOverflow: true,
    touchRatio: 1,
    touchAngle: 45,
    initialSlide: 0,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
      pageUpDown: true
    },
    mousewheel: {
      invert: false,
      sensitivity: 2,
      eventsTarget: ".new-products-swiper"
    },
    pagination: {
      el: ".new-products .swiper-pagination",
      type: "bullets",
      clickable: true
    }
  });
